import { useEffect } from "react";
import { IHook } from "./gamePrize.types";

export const useGamePrize: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
